import React from 'react'
import { Button, Paper, Chip, useTheme } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import EmailIcon from '@mui/icons-material/Email'
import LanguageIcon from '@mui/icons-material/Language'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import Text from '../Text'
import MetaOficialBenefits from './MetaOficialBenefits'
import { NOME_PRODUTO } from '../../libs/marca'

const FALLBACK_CONTACT = {
  brandName: NOME_PRODUTO,
  whatsappLink: null,
  email: null,
  siteUrl: 'https://myhs.app',
  ctaMessage: null,
}

function MetaOficialUpgradeNotice({ upgradeContact }) {
  const theme = useTheme()
  const cleanContact = upgradeContact
    ? Object.fromEntries(
        Object.entries(upgradeContact).filter(
          ([, v]) => v !== null && v !== undefined && v !== ''
        )
      )
    : {}
  const contact = {
    ...FALLBACK_CONTACT,
    ...cleanContact,
  }

  const hasAnyChannel = !!(contact.whatsappLink || contact.email || contact.siteUrl)

  const openExternal = (url) => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="col-span-12 pt-4">
      <div
        className="mb-5 border-l-4 pl-3"
        style={{ borderColor: theme.palette.primary.main }}
      >
        <div className="flex items-center space-x-3 flex-wrap">
          <Text className="text-xl font-black">
            Whatsapp Cloud API Oficial
          </Text>
          <Chip
            icon={<LockIcon style={{ fontSize: 14 }} />}
            label="Disponível como upgrade"
            size="small"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: '#fff',
              fontWeight: 700,
              '.MuiChip-icon': { color: '#fff' },
            }}
          />
        </div>
        <Text className="font-light mt-1">
          Esta integração não está inclusa no seu plano atual.
        </Text>
      </div>

      <Paper elevation={2}>
        <div className="p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          <div className="space-y-5">
            <div className="flex items-start space-x-3">
              <div
                className="w-[42px] h-[42px] rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: theme.palette.primary.main }}
              >
                <ArrowUpwardIcon style={{ fontSize: 24, color: '#fff' }} />
              </div>
              <div>
                <Text className="text-lg font-black">
                  Faça upgrade para liberar a Meta Oficial
                </Text>
                <Text className="text-sm font-light mt-1">
                  {contact.ctaMessage
                    ? contact.ctaMessage
                    : `Fale com ${contact.brandName} para conhecer os planos que incluem a integração oficial do WhatsApp Business Cloud.`}
                </Text>
              </div>
            </div>

            {hasAnyChannel && (
              <div className="pt-2 border-t" style={{ borderColor: 'rgba(128,128,128,0.18)' }}>
                <Text className="text-xs font-bold uppercase tracking-wider mb-3 opacity-70">
                  Fale com {contact.brandName}
                </Text>
                <div className="flex flex-wrap gap-3">
                  {contact.whatsappLink && (
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<WhatsAppIcon />}
                      onClick={() => openExternal(contact.whatsappLink)}
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: '#fff',
                        fontWeight: 700,
                        '&:hover': {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      }}
                    >
                      Falar agora no WhatsApp
                    </Button>
                  )}
                  {contact.email && (
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<EmailIcon />}
                      onClick={() => openExternal(`mailto:${contact.email}`)}
                    >
                      {contact.email}
                    </Button>
                  )}
                  {contact.siteUrl && (
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<LanguageIcon />}
                      onClick={() => openExternal(contact.siteUrl)}
                    >
                      Visitar site
                    </Button>
                  )}
                </div>
              </div>
            )}

            {!hasAnyChannel && (
              <div className="pt-2 border-t" style={{ borderColor: 'rgba(128,128,128,0.18)' }}>
                <Text className="text-sm font-light">
                  Entre em contato com seu provedor para mais informações sobre o upgrade.
                </Text>
              </div>
            )}
          </div>

          <div className="md:border-l md:pl-10" style={{ borderColor: 'rgba(128,128,128,0.18)' }}>
            <MetaOficialBenefits variant="inline" />
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default MetaOficialUpgradeNotice
